module.exports = __webpack_public_path__ + "assets/img/chef-1.2941c910.jpg";